<app-nav-bar [categories]="categoryList" (selectedCategory)="displayTags()"></app-nav-bar>

<div class="max-w-[1360px] mx-auto px-5 py-7 lg:py-10">
    <div class="max-w-[1150px] mx-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pb-5 md:pb-7 lg:pb-10">
            <div class="border border-secondary-button-black rounded-[20px] p-5 md:p-6 lg:p-[30px]">
                <div class="flex items-center justify-between gap-2.5 mb-4">
                    <div class="flex flex-col gap-2.5 w-[calc(100%-130px)]">
                        <p class="text-base font-medium text-secondary-text-black !leading-3">
                            Profit
                        </p>
                        <h2 class="text-black md:text-xl lg:text-3xl !leading-6 font-bold max-[576px]:text-xl">{{
                            formatCurrency(profitSnapshot?.total_profit) }}</h2>
                    </div>
                    <p
                        class="flex items-end justify-center gap-3 text-base font-medium bg-secondary-button-black !leading-3 rounded-[5px] p-2.5">
                        <svg class="max-[576px]:hidden" xmlns="http://www.w3.org/2000/svg" width="22" height="16"
                            viewBox="0 0 22 16" fill="none">
                            <path d="M0.767578 10.75C2.96715 10.75 4.75026 12.5331 4.75026 14.7327" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16.75 14.7327V14.6408C16.75 12.492 18.492 10.75 20.6408 10.75" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M4.75026 0.765625C4.75026 2.9652 2.96715 4.74831 0.767578 4.74831" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16.75 0.765625C16.75 2.94595 18.519 4.71706 20.6923 4.7479" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.75 0.75H6.75C3.92157 0.75 2.50736 0.75 1.62868 1.62868C0.75 2.50736 0.75 3.92157 0.75 6.75V8.75C0.75 11.5784 0.75 12.9926 1.62868 13.8713C2.50736 14.75 3.92157 14.75 6.75 14.75H14.75C17.5784 14.75 18.9926 14.75 19.8713 13.8713C20.75 12.9926 20.75 11.5784 20.75 8.75V6.75C20.75 3.92157 20.75 2.50736 19.8713 1.62868C18.9926 0.75 17.5784 0.75 14.75 0.75Z"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M13.75 7.75C13.75 9.4069 12.4069 10.75 10.75 10.75C9.0931 10.75 7.75 9.4069 7.75 7.75C7.75 6.09315 9.0931 4.75 10.75 4.75C12.4069 4.75 13.75 6.09315 13.75 7.75Z"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <svg class="hidden max-[576px]:block shrink-0" xmlns="http://www.w3.org/2000/svg" width="19"
                            height="10" viewBox="0 0 19 10" fill="none">
                            <path
                                d="M0.178571 0H18.1071C18.2071 0 18.2857 0.0785714 18.2857 0.178571V9.82143C18.2857 9.92143 18.2071 10 18.1071 10H0.178571C0.0785714 10 0 9.92143 0 9.82143V0.178571C0 0.0785714 0.0785714 0 0.178571 0Z"
                                fill="#1CAE91" />
                            <path d="M1.07141 1.07031H17.2143V8.92746H1.07141V1.07031Z" fill="#88FFE7" />
                            <path
                                d="M16.5001 3.38192V6.6212C16.5001 6.73192 16.4036 6.81406 16.2929 6.79621C16.0108 6.75692 15.6929 6.82835 15.3786 7.04621C15.1215 7.36763 15.0393 7.71049 15.0822 8.01049C15.0965 8.11763 15.0143 8.21406 14.9072 8.21406H3.37862C3.26791 8.21406 3.18577 8.11763 3.20362 8.01049C3.24648 7.71049 3.16434 7.36763 2.9072 7.04621C2.58934 6.82835 2.27505 6.75692 1.99291 6.79621C1.88577 6.81049 1.78577 6.72835 1.78577 6.6212V3.38192C1.78577 3.27121 1.8822 3.18906 1.99291 3.20692C2.27505 3.24621 2.59291 3.17478 2.9072 2.95692C3.16434 2.63549 3.24648 2.29263 3.20362 1.99263C3.18934 1.88549 3.27148 1.78906 3.37862 1.78906H14.9036C15.0108 1.78906 15.0965 1.88549 15.0786 1.99263C15.0358 2.29263 15.1179 2.63549 15.3751 2.95692C15.6929 3.17478 16.0072 3.24621 16.2893 3.20692C16.4036 3.19263 16.5001 3.27478 16.5001 3.38192Z"
                                fill="#1CAE91" />
                            <path
                                d="M9.14207 7.67746C10.6214 7.67746 11.8206 6.47822 11.8206 4.99888C11.8206 3.51955 10.6214 2.32031 9.14207 2.32031C7.66274 2.32031 6.4635 3.51955 6.4635 4.99888C6.4635 6.47822 7.66274 7.67746 9.14207 7.67746Z"
                                fill="#88FFE7" />
                            <path
                                d="M14.1617 5.89118C14.6548 5.89118 15.0545 5.49144 15.0545 4.99833C15.0545 4.50521 14.6548 4.10547 14.1617 4.10547C13.6685 4.10547 13.2688 4.50521 13.2688 4.99833C13.2688 5.49144 13.6685 5.89118 14.1617 5.89118Z"
                                fill="#88FFE7" />
                            <path
                                d="M4.1254 5.89118C4.61851 5.89118 5.01826 5.49144 5.01826 4.99833C5.01826 4.50521 4.61851 4.10547 4.1254 4.10547C3.63229 4.10547 3.23254 4.50521 3.23254 4.99833C3.23254 5.49144 3.63229 5.89118 4.1254 5.89118Z"
                                fill="#88FFE7" />
                            <path
                                d="M9.86723 5.05112C9.78865 4.97969 9.69223 4.9154 9.58151 4.85826C9.51008 4.81897 9.43151 4.78326 9.35294 4.74754V4.05826C9.36365 4.06897 9.3708 4.07969 9.38151 4.0904C9.43508 4.1654 9.46008 4.27254 9.46008 4.41183H10.1351C10.1351 4.15826 10.0637 3.95112 9.92437 3.78326C9.78508 3.61897 9.59223 3.51897 9.34937 3.48326V3.05469H9.03151V3.47612C8.77794 3.50112 8.57437 3.58683 8.42437 3.72969C8.27437 3.87254 8.1958 4.06183 8.1958 4.28683C8.1958 4.42254 8.21723 4.53683 8.26008 4.62969C8.30294 4.72254 8.36365 4.80826 8.44223 4.87969C8.5208 4.95112 8.61723 5.0154 8.72794 5.06897C8.81008 5.10826 8.8958 5.14754 8.98865 5.1904V5.92612C8.93865 5.90826 8.8958 5.87612 8.86008 5.83683C8.79223 5.75826 8.76008 5.6404 8.76008 5.4904H8.08508C8.08508 5.7654 8.16365 5.9904 8.31723 6.15826C8.4708 6.32612 8.6958 6.42612 8.98508 6.45826V6.86183H9.30294V6.46183C9.55294 6.43683 9.74937 6.35469 9.89223 6.20826C10.0351 6.0654 10.1101 5.87969 10.1101 5.65112C10.1101 5.5154 10.0887 5.40112 10.0422 5.30469C10.0101 5.20826 9.94937 5.12254 9.86723 5.05112ZM8.87794 4.29397C8.87794 4.19754 8.90294 4.11897 8.94937 4.0654C8.97437 4.03683 9.00294 4.0154 9.03508 4.00469V4.59397C9.00651 4.57254 8.97794 4.55112 8.96008 4.52969C8.90651 4.46897 8.87794 4.39397 8.87794 4.29397ZM9.3708 5.87612C9.35294 5.89397 9.33508 5.90826 9.31365 5.91897V5.35469C9.33508 5.37254 9.35294 5.3904 9.3708 5.40469C9.42437 5.4654 9.44937 5.54754 9.44937 5.65112C9.44937 5.74754 9.42437 5.82254 9.3708 5.87612Z"
                                fill="#1CAE91" />
                        </svg>
                        {{ formatCurrency(profitSnapshot?.portfolio_value) }}
                    </p>
                </div>
                <p class="text-secondary-text-black text-base font-medium max-[576px]:text-sm">
                    <span
                        [ngClass]="(profitSnapshot?.today_profit || '').startsWith('-') ? 'text-primary-text-yellow' : 'text-primary-text-green'">
                        {{ formatCurrency(profitSnapshot?.today_profit) }}({{ profitSnapshot?.percent_change || '0.00'
                        }}%)
                    </span>
                    Today
                </p>
                <div class="grid grid-cols-2 max-[576px]:grid-cols-1 mt-4 md:mt-6 lg:mt-[30px] gap-4 md:gap-5">
                    <button (click)="openDepositModal()"
                        class="flex items-center justify-center gap-2.5 font-syne font-semibold bg-black text-white border border-transparent rounded-lg cursor-pointer hover:bg-secondary-button-black hover:text-black hover:border-black duration-200 ease-in-out py-3 px-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M2 11.3335C2 11.9535 2 12.2635 2.06815 12.5178C2.25309 13.208 2.79218 13.7471 3.48237 13.932C3.7367 14.0002 4.04669 14.0002 4.66667 14.0002H11.3333C11.9533 14.0002 12.2633 14.0002 12.5177 13.932C13.2078 13.7471 13.7469 13.208 13.9319 12.5178C14 12.2635 14 11.9535 14 11.3335"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M11 7.66682C11 7.66682 8.79056 10.6668 7.99996 10.6668C7.20943 10.6668 5 7.66682 5 7.66682M7.99996 10.0001V2.00012"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Deposit
                    </button>
                    <button (click)="openWithdrawModal()" [disabled]="availableCashBalance <= 0"
                        [ngClass]="{'opacity-50 !cursor-not-allowed': availableCashBalance <= 0}"
                        class="flex items-center justify-center gap-2.5 font-syne font-semibold bg-secondary-button-black text-black border border-black rounded-lg cursor-pointer hover:bg-black hover:text-white hover:border-black duration-200 ease-in-out py-3 px-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M2 11.3335C2 11.9535 2 12.2635 2.06815 12.5178C2.25309 13.208 2.79218 13.7471 3.48237 13.932C3.7367 14.0002 4.04669 14.0002 4.66667 14.0002H11.3333C11.9533 14.0002 12.2633 14.0002 12.5177 13.932C13.2078 13.7471 13.7469 13.208 13.9319 12.5178C14 12.2635 14 11.9535 14 11.3335"
                                stroke="currentColor" stroke-opacity="0.8" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M4.99997 4.99957C4.99997 4.99957 7.20944 1.99957 8.00004 1.99957C8.79057 1.99957 11 4.99957 11 4.99957M8.00004 2.66623L8.00004 10.6663"
                                stroke="currentColor" stroke-opacity="0.8" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        Withdraw
                    </button>
                </div>
            </div>

            <div class="border border-secondary-button-black rounded-[20px] p-5 md:p-6 lg:p-[30px]">
                <div class="flex items-center justify-between">
                    <div class="flex flex-col gap-2.5">
                        <p class="flex items-center gap-1.5 text-base font-medium text-secondary-text-black !leading-3">
                            Profit/Loss
                        </p>
                        <h2 class="text-black md:text-xl lg:text-3xl !leading-6 font-bold max-[576px]:text-xl">{{
                            formatCurrency(currentProfitLossValue, true) }}</h2>
                    </div>
                    <ul class="flex flex-wrap items-center gap-2.5 max-[576px]:text-sm max-[576px]:gap-1.5">
                        <li (click)="setProfitInterval('1D')"
                            [ngClass]="activeProfitInterval === '1D' ? 'text-black font-medium rounded-[5px] bg-secondary-button-black border border-black px-2.5 pt-2.5 pb-2 cursor-pointer' : 'text-base !leading-3 text-secondary-text-black font-medium rounded-[5px] px-2.5 pt-2.5 pb-2 cursor-pointer'">
                            1D</li>
                        <li (click)="setProfitInterval('1M')"
                            [ngClass]="activeProfitInterval === '1M' ? 'text-black font-medium rounded-[5px] bg-secondary-button-black border border-black px-2.5 pt-2.5 pb-2 cursor-pointer' : 'text-base !leading-3 text-secondary-text-black font-medium rounded-[5px] px-2.5 pt-2.5 pb-2 cursor-pointer'">
                            1M</li>
                        <li (click)="setProfitInterval('1W')"
                            [ngClass]="activeProfitInterval === '1W' ? 'text-black font-medium rounded-[5px] bg-secondary-button-black border border-black px-2.5 pt-2.5 pb-2 cursor-pointer' : 'text-base !leading-3 text-secondary-text-black font-medium rounded-[5px] px-2.5 pt-2.5 pb-2 cursor-pointer'">
                            1W</li>
                        <li (click)="setProfitInterval('ALL')"
                            [ngClass]="activeProfitInterval === 'ALL' ? 'text-black font-medium rounded-[5px] bg-secondary-button-black border border-black px-2.5 pt-2.5 pb-2 cursor-pointer' : 'text-base !leading-3 text-secondary-text-black font-medium rounded-[5px] px-2.5 pt-2.5 pb-2 cursor-pointer'">
                            ALL</li>
                    </ul>
                </div>
                <p class="text-base font-medium text-secondary-text-black !leading-3 my-5">
                    {{ activeProfitInterval === 'ALL' ? 'All Time' : activeProfitInterval }}
                </p>
                <div class="mb-5">
                    <app-chart [chartData]="profitChartData" [showControls]="false" chartType="profit"
                        [activeInterval]="activeProfitInterval">
                    </app-chart>
                </div>
            </div>
        </div>

        <div *ngIf="hasClaimable" class="mt-6 mb-4">
            <h2 class="text-2xl font-bold mb-3 max-[576px]:text-base max-[767px]:text-xl">Claim Your Winnings</h2>

            <div class="space-y-4">
                <div *ngFor="let item of claimDetails" class="border border-gray-300 p-4 rounded-lg bg-white">

                    <div class="flex justify-between items-center gap-4 max-[576px]:text-sm">
                        <div>
                            <p>{{ item.name || 'Market Name' }}</p>
                            <p>Winner Outcome: {{ item.winner_outcome }}</p>
                            <h2>${{ item.claimable_amount.toFixed(2) }}</h2>
                        </div>

                        <button (click)="onRedeem(item)" [disabled]="item.isProcessing"
                            class="bg-black text-white px-4 py-2 rounded">
                            {{ item.isProcessing ? 'Processing...' : 'Redeem' }}
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div class="rounded-xl border border-secondary-button-black">
            <div class="px-5 pt-6">
                <ul class="flex items-center gap-6 border-b border-secondary-button-black">
                    <li (click)="setTab(PortfolioTab.POSITIONS)"
                        class="cursor-pointer text-base md:text-lg lg:text-xl font-medium border-b-2 pb-3" [ngClass]="
                        activeTab === PortfolioTab.POSITIONS
                            ? 'text-black border-primary-text-green'
                            : 'text-secondary-text-black border-transparent'
                    ">
                        Positions
                    </li>

                    <li (click)="setTab(PortfolioTab.ORDERS)"
                        class="cursor-pointer text-base md:text-lg lg:text-xl font-medium border-b-2 pb-3" [ngClass]="
                        activeTab === PortfolioTab.ORDERS
                            ? 'text-black border-primary-text-green'
                            : 'text-secondary-text-black border-transparent'
                    ">
                        Open Orders
                    </li>

                    <li (click)="setTab(PortfolioTab.HISTORY)"
                        class="cursor-pointer text-base md:text-lg lg:text-xl font-medium border-b-2 pb-3" [ngClass]="
                        activeTab === PortfolioTab.HISTORY
                            ? 'text-black border-primary-text-green'
                            : 'text-secondary-text-black border-transparent'
                    ">
                        History
                    </li>
                </ul>
            </div>
            <!-- position tabs -->

            <div *ngIf="activeTab === PortfolioTab.POSITIONS">

                <!-- Search + Current Value dropdown -->
                <div class="p-4 md:py-6 md:px-5 flex flex-row max-[480px]:flex-col gap-5">

                    <!-- Search -->
                    <div
                        class="flex items-end gap-3.5 rounded-xl border border-secondary-button-black px-6 py-3 w-full">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>

                        <input type="text" placeholder="Search" (input)="onSearchPositions($event)"
                            [value]="searchQuery"
                            class="placeholder:text-[#00000059] text-black text-base font-normal !leading-3 border-0 outline-0 p-0 w-full" />
                    </div>

                    <!-- Current Value dropdown -->
                    <div class="relative current-value-dropdown inline-flex">

                        <!-- Button -->
                        <button #valueTrigger type="button" (click)="toggleDropdown()"
                            class="flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-5 py-4 cursor-pointer w-auto whitespace-nowrap max-[576px]:text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <g clip-path="url(#clip0_4839_36594)">
                                    <path d="M1 5.66406L9.55556 5.66412" stroke="black" stroke-width="1.16667"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M1 10.3359H6.44444" stroke="black" stroke-width="1.16667"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M1 1H13.4444" stroke="black" stroke-width="1.16667" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M13.0577 14.9974V5.66406M13.0577 14.9974C12.5131 14.9974 11.4956 13.4463 11.1133 13.053M13.0577 14.9974C13.6023 14.9974 14.6199 13.4463 15.0022 13.053"
                                        stroke="black" stroke-width="1.16667" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_4839_36594">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>{{ selectedValue }}</span>
                        </button>

                        <!-- Dropdown -->
                        <ul *ngIf="isValueDropdownOpen" [style.maxHeight.px]="valueMenu.maxHeight"
                            [ngClass]="valueMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                            class="custom-scroll absolute z-20 w-[175px] rounded-xl border border-secondary-button-black bg-white shadow-lg overflow-y-auto overflow-x-hidden overscroll-contain">
                            <li *ngFor="let option of positionSortOptions" (click)="selectValue(option)"
                                class="text-sm font-medium cursor-pointer border-b border-secondary-button-black last:border-0 hover:bg-light-black-300 px-[18px] py-[11px]">
                                {{ option.label }}
                            </li>
                        </ul>

                    </div>


                </div>

                <!-- TABLE CONTAINER: with nothing to list there is no table at all,
                     only the placeholder below. The loading state still gets one so the
                     spinner inside it stays visible while the first page is fetched. -->
                <div *ngIf="positions.length > 0 || isLoadingPositions"
                    class="positions-table w-full overflow-y-auto max-h-[750px]" (scroll)="onPositionsScroll($event)">

                    <!-- TABLE HEADER -->
                    <div
                        class="flex items-center border-b border-secondary-button-black px-5 py-3 gap-8 font-medium text-secondary-text-black text-sm md:text-base sticky top-0 bg-white z-10">
                        <div class="flex-[2.5] min-w-0">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Market
                            </p>
                        </div>
                        <div class="flex-[1] min-w-0 flex items-center gap-1">
                            <p
                                class="flex items-center gap-1 text-base font-normal tracking-[-0.4px] text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Avg → Now
                                <span class="relative group flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                        fill="none">
                                        <g clip-path="url(#clip0)">
                                            <path
                                                d="M7.0013 12.8346C10.223 12.8346 12.8346 10.223 12.8346 7.0013C12.8346 3.77964 10.223 1.16797 7.0013 1.16797C3.77964 1.16797 1.16797 3.77964 1.16797 7.0013C1.16797 10.223 3.77964 12.8346 7.0013 12.8346Z"
                                                stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 9.33203V6.70703" stroke="black" stroke-opacity="0.5"
                                                stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 4.67356V4.66772" stroke="black" stroke-opacity="0.5"
                                                stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                                <rect width="14" height="14" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div
                                        class="absolute left-full ml-2 top-1/2 -translate-y-1/2 w-max opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 bg-black text-white text-xs font-normal rounded-lg px-3 py-1.5 z-[100] shadow-xl text-center leading-relaxed whitespace-nowrap cursor-default pointer-events-none">
                                        Your average buy price per share vs the current price
                                        <div
                                            class="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-black">
                                        </div>
                                    </div>
                                </span>
                                <!-- <button>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                        fill="none">
                                        <path
                                            d="M10.5 5.25003C10.5 5.25003 7.92231 8.75 7 8.75C6.07763 8.75 3.5 5.25 3.5 5.25"
                                            stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button> -->
                            </p>
                        </div>
                        <div class="flex-[1] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Bet
                            </p>
                        </div>
                        <div class="flex-[1] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">To win</p>
                        </div>
                        <div class="flex-[1] min-w-0 text-right">
                            <button
                                class="w-full flex items-center justify-end gap-1 text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Value
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                    fill="none">
                                    <path
                                        d="M10.5 5.25003C10.5 5.25003 7.92231 8.75 7 8.75C6.07763 8.75 3.5 5.25 3.5 5.25"
                                        stroke="black" stroke-opacity="0.5" stroke-width="0.875" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                        <div class="flex-[1.3] min-w-0"></div>
                    </div>

                    <!-- TABLE ROWS -->
                    <div *ngFor="let item of positions"
                        class="flex items-center border-b border-secondary-button-black last:border-0 px-5 py-4 gap-8">

                        <!-- Market -->
                        <div class="flex-[2.5] min-w-0 flex items-center gap-3 cursor-pointer group"
                            (click)="navigateToMarket(item.market_id)">
                            <div class="w-[50px] h-[50px] shrink-0">
                                <img [src]="item.image"
                                    class="w-full h-full rounded-full object-cover group-hover:opacity-80 transition-opacity" />
                            </div>
                            <div class="flex flex-col min-w-0">
                                <p class="text-black font-medium text-lg truncate group-hover:underline max-[576px]:text-sm">{{
                                    item.question }}</p>
                                <div class="flex items-center gap-2 text-sm text-secondary-text-black">
                                    <span class="px-2 py-0.5 rounded bg-primarybg-green text-primary-text-green">{{
                                        item.team }}</span>
                                    <span class="text-lg max-[576px]:text-sm">{{ item.sharesText }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Avg → Now -->
                        <div class="flex-[1] min-w-0 flex items-start gap-1 text-lg max-[576px]:text-sm">
                            {{ item.avg }} → <span class="text-black">{{ item.now }}</span>
                        </div>

                        <!-- Bet -->
                        <div class="flex-[1] min-w-0 text-start text-black font-medium text-lg max-[576px]:text-sm">
                            {{ item.bet }}
                        </div>

                        <!-- To Win -->
                        <div class="flex-[1] min-w-0 text-start text-black font-medium text-lg max-[576px]:text-sm">
                            {{ item.toWin }}
                        </div>

                        <!-- Value + PnL -->
                        <div class="flex-[1] min-w-0 flex flex-col items-end text-right gap-1 text-lg max-[576px]:text-sm">
                            <!-- LOST badge -->
                            <div *ngIf="item.isLost"
                                class="flex items-center gap-1 text-xs font-bold text-[#dc2626] uppercase mb-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                </svg>
                                Lost
                            </div>
                            <!-- WON badge -->
                            <div *ngIf="item.isWon"
                                class="flex items-center gap-1 text-xs font-bold text-[#2ECC71] uppercase mb-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="9 12 12 15 16 9"></polyline>
                                </svg>
                                Won
                            </div>
                            <!-- Value: $0.00 if lost, actual value otherwise -->
                            <span class="font-medium"
                                [ngClass]="{'text-[#dc2626]': item.isLost, 'text-[#2ECC71]': item.isWon, 'text-black': !item.isLost && !item.isWon}">
                                {{ item.isLost ? '$0.00' : item.value }}
                            </span>
                            <!-- PnL: only show if not lost and not won -->
                            <span *ngIf="!item.isLost && !item.isWon" class="text-sm whitespace-nowrap"
                                [ngClass]="item.isProfit ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                {{ item.totalPnl }} ({{ item.pnlPercent }})
                            </span>
                        </div>

                        <!-- Actions -->
                        <div class="flex-[1.3] min-w-0 flex items-center justify-end gap-3.5">
                            <button *ngIf="item.is_winner_declared" (click)="onRedeem(item)"
                                [disabled]="item.isProcessing"
                                class="px-[30px] pt-3 pb-2.5 bg-black text-white rounded-lg text-sm hover:bg-secondary-button-black hover:text-black cursor-pointer duration-200 ease-in-out">
                                {{ item.isProcessing ? 'Processing...' : 'Redeem' }}
                            </button>
                            <button *ngIf="!item.is_winner_declared" (click)="openSellNoModal(item)"
                                class="px-[30px] pt-3 pb-2.5 bg-black text-white rounded-lg text-sm hover:bg-secondary-button-black hover:text-black cursor-pointer duration-200 ease-in-out">
                                Sell
                            </button>
                            <button (click)="openSellNoModal(item)"
                                class="hidden h-10 w-10 border border-secondary-button-black rounded-md flex items-center justify-center hover:bg-light-black-300 cursor-pointer duration-200 ease-in-out">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M3 17C3 17.93 3 18.395 3.10222 18.7765C3.37962 19.8117 4.18826 20.6204 5.22354 20.8978C5.60504 21 6.07002 21 7 21H17C17.93 21 18.3949 21 18.7764 20.8978C19.8117 20.6204 20.6203 19.8117 20.8977 18.7765C20.9999 18.395 21 17.93 21 17"
                                        stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M16.5 7.49997C16.5 7.49997 13.1858 3.00001 12 3C10.8142 2.99999 7.5 7.5 7.5 7.5M12 4V16"
                                        stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>

                    </div>

                    <!-- LOADING INDICATOR -->
                    <div *ngIf="isLoadingPositions" class="flex items-center justify-center px-5 py-6">
                        <div class="flex items-center gap-2">
                            <div class="w-4 h-4 rounded-full bg-black animate-pulse"></div>
                            <span class="text-sm text-secondary-text-black">Loading more...</span>
                        </div>
                    </div>

                    <!-- END OF LIST MESSAGE -->
                    <div *ngIf="positions && positions.length > 0 && !hasMorePositions && !isLoadingPositions"
                        class="flex items-center justify-center px-5 py-6">
                        <p class="text-sm text-secondary-text-black">No more positions to load</p>
                    </div>

                </div>

                <!-- EMPTY STATE -->
                <p *ngIf="positions.length === 0 && !isLoadingPositions"
                    class="w-full text-center text-sm md:text-base lg:text-lg font-medium text-secondary-text-black my-10">
                    No positions found
                </p>

            </div>


            <!-- orders-tabs -->
            <div *ngIf="activeTab === PortfolioTab.ORDERS">
                <!-- Search + Current Value dropdown -->
                <div
                    class="p-4 md:py-6 md:px-5 flex flex-row max-[480px]:flex-col items-center max-[480px]:items-stretch justify-between gap-5">

                    <!-- Search -->
                    <div
                        class="flex items-end gap-3.5 rounded-xl border border-secondary-button-black px-6 py-3 w-full min-w-0">
                        <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>

                        <input type="text" placeholder="Search" (input)="onSearchOrders($event)"
                            [value]="ordersSearchQuery"
                            class="placeholder:text-[#00000059] text-black text-base font-normal !leading-3 border-0 outline-0 p-0 w-full min-w-0" />
                    </div>

                    <div class="flex items-center gap-3 shrink-0  max-[480px]:w-full">
                        <!-- Sort Dropdown -->
                        <div class="relative current-value-dropdown inline-flex">
                            <button #orderSortTrigger type="button" (click)="toggleOrderSortDropdown()"
                                class="flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-5 py-4 cursor-pointer w-auto whitespace-nowrap max-[576px]:text-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                    fill="none">
                                    <path d="M3 4H13M3 8H10M3 12H7" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>{{ selectedOrderSort }}</span>
                            </button>

                            <!-- On <=480px the button sits at the left of a full-width row, so anchor the panel left -->
                            <ul *ngIf="isSortDropdownOpen" [style.maxHeight.px]="orderSortMenu.maxHeight"
                                [ngClass]="orderSortMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                                class="absolute right-0 max-[480px]:right-auto max-[480px]:left-0 z-20 w-[175px] max-w-[calc(100vw-2rem)] rounded-xl border border-secondary-button-black bg-white shadow-lg overflow-y-auto overscroll-contain">
                                <li *ngFor="let option of marketOptions" (click)="selectOrderSort(option)"
                                    class="text-sm font-medium cursor-pointer border-b border-secondary-button-black last:border-0 hover:bg-light-black-300 px-[18px] py-[11px]">
                                    {{ option }}
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>

                <!-- TABLE CONTAINER: hidden outright when there is nothing to list -->
                <div *ngIf="(orders && orders.length > 0) || isLoadingOrders"
                    class="orders-table w-full overflow-y-auto max-h-[750px]" (scroll)="onOrdersScroll($event)">

                    <!-- TABLE HEADER -->
                    <div
                        class="flex items-center border-b border-secondary-button-black px-5 py-3 gap-6 font-medium text-secondary-text-black text-sm md:text-base sticky top-0 bg-white z-10">
                        <div class="flex-[2.5] min-w-0">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Market
                            </p>
                        </div>
                        <div class="flex-[0.7] min-w-0 flex items-center gap-1">
                            <p
                                class="flex items-center gap-1 text-base font-normal tracking-[-0.4px] text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Side
                            </p>
                        </div>
                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">
                                Outcome
                            </p>
                        </div>
                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">Price</p>
                        </div>
                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">Filled/Total</p>
                        </div>
                        <div class="flex-[0.5] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">Total Amount</p>
                        </div>
                        <div class="flex-[0.5] min-w-0 text-start">
                            <p class="text-base font-normal text-secondary-text-black cursor-pointer max-[576px]:text-sm">Expiration</p>
                        </div>
                        <div class="flex-[0.5] min-w-0 text-start">
                        </div>

                    </div>

                    <!-- TABLE ROWS -->
                    <div *ngFor="let order of orders"
                        class="flex items-center border-b border-secondary-button-black last:border-0 px-5 py-4 gap-6">
                        <div class="flex-[2.5] min-w-0 flex items-center gap-3 cursor-pointer group"
                            (click)="navigateToMarket(order.market_id)">
                            <div class="w-[50px] h-[50px] shrink-0">
                                <img [src]="order.market_image || 'assets/images/leaderboard/nfl.png'"
                                    class="w-full h-full rounded-full object-cover group-hover:opacity-80 transition-opacity" />
                            </div>
                            <div class="flex flex-col min-w-0">
                                <p class="text-black font-medium text-lg line-clamp-2 group-hover:underline max-[576px]:text-sm">{{
                                    order.market_name || 'Market Question' }}</p>
                            </div>
                        </div>

                        <div class="flex-[0.7] min-w-0 flex items-start gap-1">
                            <p class="font-medium text-lg max-[576px]:text-sm"
                                [ngClass]="order.side === 'BUY' ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                {{ order.side }}</p>
                        </div>

                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-black font-medium text-lg max-[576px]:text-sm">{{ order.outcome }}</p>
                        </div>

                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-black font-medium text-lg max-[576px]:text-sm">{{ formatPrice(order.price) }}</p>
                        </div>

                        <div class="flex-[0.7] min-w-0 text-start">
                            <p class="text-black font-medium text-lg max-[576px]:text-sm">{{ order.filled }}/{{ order.total }}</p>
                        </div>

                        <div class="flex-[0.5] min-w-0">
                            <p class="text-black font-medium text-lg max-[576px]:text-sm">{{ order.total_amount ? '$' + order.total_amount :
                                '$0.00' }}</p>
                        </div>

                        <div class="flex-[0.5] min-w-0">
                            <p class="text-black font-medium text-lg max-[576px]:text-sm">{{ order.status }}</p>
                        </div>

                        <div class="flex-[0.5] min-w-0">
                            <!-- <button
                                class="h-10 w-10 border border-secondary-button-black rounded-md flex items-center justify-center hover:bg-light-black-300 cursor-pointer duration-200 ease-in-out">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085" stroke="black"
                                        stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button> -->
                        </div>


                    </div>

                    <!-- LOADING INDICATOR -->
                    <div *ngIf="isLoadingOrders" class="flex items-center justify-center px-5 py-6">
                        <div class="flex items-center gap-2">
                            <div class="w-4 h-4 rounded-full bg-black animate-pulse"></div>
                            <span class="text-sm text-secondary-text-black">Loading more...</span>
                        </div>
                    </div>

                    <!-- END OF LIST MESSAGE -->
                    <div *ngIf="orders && orders.length > 0 && !hasMoreOrders && !isLoadingOrders"
                        class="flex items-center justify-center px-5 py-6">
                        <p class="text-sm text-secondary-text-black">No more orders to load</p>
                    </div>

                </div>

                <!-- EMPTY STATE -->
                <p *ngIf="orders && orders.length === 0 && !isLoadingOrders"
                    class="w-full text-center text-sm md:text-base lg:text-lg font-medium text-secondary-text-black my-10">
                    No open orders found
                </p>
            </div>

            <!-- history-tabs -->
            <div *ngIf="activeTab === PortfolioTab.HISTORY">
                <!-- Search + Current Value dropdown -->
                <div class="p-4 md:py-6 md:px-5 flex flex-col md:flex-row gap-5 md:items-center md:justify-between">

                    <!-- Search -->
                    <div
                        class="h-[50px] flex items-end gap-3.5 rounded-xl border border-secondary-button-black px-6 py-3 w-full">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>

                        <input type="text" placeholder="Search" (input)="onSearchHistory($event)"
                            [value]="historysearchQuery"
                            class="placeholder:text-[#00000059] text-black text-base font-normal !leading-3 border-0 outline-0 p-0 w-full" />
                    </div>

                    <!-- Filters: stay in a row on mobile, unwrap into the parent flex row from md up -->
                    <div class="relative flex flex-row items-center gap-3 md:contents flex-wrap">

                        <!-- All dropdown -->
                        <div class="relative inline-flex current-value-dropdown flex-1 md:flex-none">

                            <!-- Button -->
                            <button #historyAllTrigger type="button" (click)="toggleHistoryAllDropdown()"
                                class="h-[50px] w-full md:w-auto flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-4 md:px-5 py-4 cursor-pointer whitespace-nowrap max-[576px]:text-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                    fill="none" class="shrink-0">
                                    <path d="M3.08203 6.33545H12.832" stroke="black" stroke-opacity="0.8"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.16602 10.6646H10.666" stroke="black" stroke-opacity="0.8"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.33203 15H8.4987" stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2 2H13.9167" stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                {{ allSelected }}
                            </button>

                            <!-- Dropdown -->
                            <ul *ngIf="isAllOpen" [style.maxHeight.px]="historyAllMenu.maxHeight"
                                [ngClass]="historyAllMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                                class="absolute z-20 w-[175px] rounded-xl border border-secondary-button-black bg-white shadow-lg overflow-y-auto overscroll-contain">
                                <li *ngFor="let option of allOptions" (click)="setHistoryAll(option)"
                                    class="text-sm font-medium cursor-pointer border-b border-secondary-button-black last:border-0 hover:bg-light-black-300 px-[18px] py-[11px]">
                                    {{ option }}
                                </li>
                            </ul>

                        </div>


                        <!-- Newest dropdown -->
                        <div class="relative inline-flex current-value-dropdown flex-1 md:flex-none">

                            <!-- Button -->
                            <button #historyNewestTrigger type="button" (click)="toggleHistoryNewestDropdown()"
                                class="h-[50px] w-full md:w-auto flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-4 md:px-5 py-4 cursor-pointer whitespace-nowrap max-[576px]:text-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                    fill="none" class="shrink-0">
                                    <g clip-path="url(#clip0_4755_35237)">
                                        <path d="M1 5.66602L9.55556 5.66608" stroke="black" stroke-opacity="0.8"
                                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1 10.334H6.44444" stroke="black" stroke-opacity="0.8"
                                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1 1H13.4444" stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M13.0577 14.9993V5.66602M13.0577 14.9993C12.5131 14.9993 11.4956 13.4482 11.1133 13.0549M13.0577 14.9993C13.6023 14.9993 14.6199 13.4482 15.0022 13.0549"
                                            stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4755_35237">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {{ newestSelected }}
                            </button>

                            <!-- Dropdown: anchored to the button's right edge so the 175px panel opens
                                 inwards and never spills past the container on narrow screens -->
                            <ul *ngIf="isNewestOpen" [style.maxHeight.px]="historyNewestMenu.maxHeight"
                                [ngClass]="historyNewestMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                                class="absolute right-0 z-20 w-[175px] max-w-[calc(100vw-2rem)] rounded-xl border border-secondary-button-black bg-white shadow-lg overflow-y-auto overscroll-contain">
                                <li *ngFor="let option of newestOptions" (click)="setHistoryNewest(option)"
                                    class="text-sm font-medium cursor-pointer border-b border-secondary-button-black last:border-0 hover:bg-light-black-300 px-[18px] py-[11px]">
                                    {{ option }}
                                </li>
                            </ul>

                        </div>


                        <!-- <=480px: drop the positioning context so the panel anchors to the filter row, not the icon button -->
                        <div class="relative max-[480px]:static inline-flex current-value-dropdown shrink-0">
                            <button #historyDateTrigger (click)="toggleDatePicker()"
                                class="h-[50px] flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-4 md:px-5 py-4 cursor-pointer w-auto whitespace-nowrap">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none" class="shrink-0">
                                    <path d="M13.3327 1.6665V4.99984M6.66602 1.6665V4.99984" stroke="black"
                                        stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M10.8333 3.3335H9.16667C6.02397 3.3335 4.45262 3.3335 3.47631 4.3098C2.5 5.28612 2.5 6.85746 2.5 10.0002V11.6668C2.5 14.8095 2.5 16.3809 3.47631 17.3572C4.45262 18.3335 6.02397 18.3335 9.16667 18.3335H10.8333C13.976 18.3335 15.5474 18.3335 16.5237 17.3572C17.5 16.3809 17.5 14.8095 17.5 11.6668V10.0002C17.5 6.85746 17.5 5.28612 16.5237 4.3098C15.5474 3.3335 13.976 3.3335 10.8333 3.3335Z"
                                        stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M2.5 8.3335H17.5" stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <!-- On mobile the button is icon-only; the "Dates" label shows from md up -->
                                <span *ngIf="historyStartDate">
                                    {{ (historyStartDate | date:'MMM d') + ' - ' + (historyEndDate ? (historyEndDate |
                                    date:'MMM d') : '...') }}
                                </span>
                                <span *ngIf="!historyStartDate" class="hidden md:inline">Dates</span>
                            </button>

                            <div *ngIf="isDatePickerOpen" [style.maxHeight.px]="historyDateMenu.maxHeight"
                                [ngClass]="historyDateMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                                class="absolute right-0 max-[480px]:left-0 z-20 w-[300px] max-[480px]:w-auto p-5 rounded-xl border border-secondary-button-black bg-white shadow-lg overflow-y-auto overscroll-contain">
                                <div class="flex flex-col gap-4">
                                    <div class="flex flex-col gap-2">
                                        <label class="text-xs font-semibold text-gray-500 uppercase">From</label>
                                        <input type="date" [(ngModel)]="historyStartDate" (change)="onDateChange()"
                                            class="w-full h-10 px-3 rounded-lg border border-secondary-button-black outline-none focus:border-black">
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label class="text-xs font-semibold text-gray-500 uppercase">To</label>
                                        <input type="date" [(ngModel)]="historyEndDate" (change)="onDateChange()"
                                            class="w-full h-10 px-3 rounded-lg border border-secondary-button-black outline-none focus:border-black">
                                    </div>
                                    <div class="flex gap-2 pt-2">
                                        <button (click)="clearDates()"
                                            class="flex-1 h-10 text-sm font-medium border border-secondary-button-black rounded-lg hover:bg-gray-50">Clear</button>
                                        <button (click)="applyDateFilter()"
                                            class="flex-1 h-10 text-sm font-medium bg-black text-white rounded-lg hover:bg-gray-800">Apply</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- /filters -->

                    <button (click)="exportOrderHistory()"
                        class="h-[50px] flex items-center justify-center gap-2.5 text-black text-base font-medium !leading-3 rounded-[5px] border border-secondary-button-black bg-white px-5 py-4 cursor-pointer w-auto whitespace-nowrap hover:bg-gray-50 max-[576px]:text-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M2 11.3335C2 11.9535 2 12.2635 2.06815 12.5178C2.25309 13.208 2.79218 13.7471 3.48237 13.932C3.7367 14.0002 4.04669 14.0002 4.66667 14.0002H11.3333C11.9533 14.0002 12.2633 14.0002 12.5177 13.932C13.2078 13.7471 13.7469 13.208 13.9319 12.5178C14 12.2635 14 11.9535 14 11.3335"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M11 7.66669C11 7.66669 8.79056 10.6667 7.99996 10.6667C7.20943 10.6667 5 7.66669 5 7.66669M7.99996 10V2"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        Export
                    </button>


                </div>

                <!-- TABLE CONTAINER: hidden outright when there is nothing to list -->
                <div *ngIf="(historys && historys.length > 0) || isLoadingHistory"
                    class="history-table w-full overflow-y-auto max-h-[750px] border border-secondary-button-black rounded-lg"
                    (scroll)="onHistoryScroll($event)">

                    <!-- Header -->
                    <div
                        class="flex items-center border-b border-secondary-button-black bg-gray-50/50 px-5 py-3 gap-6 font-medium text-secondary-text-black text-xs uppercase tracking-wider">
                        <div class="flex-[1.5] min-w-0">Activity</div>
                        <div class="flex-[3] min-w-0">Market</div>
                        <div class="flex-[1] min-w-0 text-end">Value</div>
                        <div class="flex-[1] min-w-0 text-end">Time</div>

                    </div>

                    <!-- Data -->
                    <ng-container *ngIf="historys && historys.length > 0">

                        <div *ngFor="let history of historys"
                            [style.display]="history.displayActivity.toLowerCase() === 'won' ? 'none' : 'flex'"
                            class="flex items-center border-b border-secondary-button-black last:border-0 px-5 py-4 gap-6 hover:bg-gray-50 transition-colors">

                            <!-- Activity -->
                            <div class="flex-[1.5] min-w-0 flex items-center gap-2">
                                <div class="text-gray-400">
                                    <i class="fas fa-circle-check"></i>
                                </div>

                                <p class="text-black font-semibold text-sm md:text-base capitalize">
                                    {{ history.displayActivity }}
                                </p>
                            </div>

                            <!-- Market -->
                            <div class="flex-[3] min-w-0 flex flex-col justify-center"
                                [class.cursor-pointer]="isHistoryMarketClickable(history)"
                                [class.group]="isHistoryMarketClickable(history)"
                                (click)="isHistoryMarketClickable(history) ? navigateToMarket(history.displayMarket?.id) : null">

                                <!-- Market Name -->
                                <p class="text-black font-medium text-sm md:text-base line-clamp-1 max-[576px]:text-sm"
                                    [class.group-hover:underline]="isHistoryMarketClickable(history)">
                                    {{ history.displayMarket?.name }}
                                </p>

                                <!-- Shares + Price  -->
                                <div class="flex items-center gap-2 mt-1 text-xs max-[576px]:text-sm">

                                    <!-- YES / NO badge -->
                                    <span class="px-2 py-0.5 rounded-full font-semibold" [ngClass]="{
                            'bg-green-100 text-green-700': history.market?.outcome_title === 'YES',
                            'bg-red-100 text-red-700': history.market?.outcome_title === 'NO'
                        }" *ngIf="history.market?.price">

                                        {{ history.market?.outcome_title }}
                                        {{ (history.market?.price * 100) | number:'1.0-0' }}¢
                                    </span>

                                    <!-- Shares -->
                                    <span class="text-gray-400" *ngIf="history.market?.shares">
                                        {{ history.market?.shares }} shares
                                    </span>


                                </div>


                            </div>

                            <!-- Value -->
                            <div class="flex-[1] min-w-0 text-end">
                                <p class="font-bold text-sm md:text-base"
                                    [ngClass]="getActivityClass(history.displayActivity)">
                                    {{ getActivitySymbol(history.displayActivity) }} ${{ history.total_execution }}
                                </p>
                            </div>
                            <div class="flex-[1] min-w-0 text-end">
                                <p class="text-secondary-text-black text-xs md:text-sm font-medium">
                                    {{ history.time_ago }}
                                </p>

                            </div>
                        </div>

                    </ng-container>

                    <!-- LOADING INDICATOR -->
                    <div *ngIf="isLoadingHistory" class="flex items-center justify-center px-5 py-6">
                        <div class="flex items-center gap-2">
                            <div class="w-4 h-4 rounded-full bg-black animate-pulse"></div>
                            <span class="text-sm text-secondary-text-black">Loading more...</span>
                        </div>
                    </div>


                    <!-- END OF LIST MESSAGE -->
                    <div *ngIf="historys && historys.length > 0 && !hasMoreHistory && !isLoadingHistory"
                        class="flex items-center justify-center px-5 py-6">
                        <p class="text-sm text-secondary-text-black">No more history to load</p>
                    </div>

                </div>
                <!-- EMPTY STATE -->
                <p *ngIf="historys && historys.length === 0 && !isLoadingHistory"
                    class="w-full text-center text-sm sm:text-base md:text-lg font-medium text-secondary-text-black my-10">
                    You haven't traded any Predictions markets yet
                </p>

            </div>

        </div>
    </div>
</div>


<app-sellno-modal *ngIf="isSellNoModalOpen" [position]="selectedSellPosition" (close)="closeSellNoModal()"
    (success)="onCashoutSuccess()" (editOrder)="onEditOrder()"></app-sellno-modal>
<app-deposit-modal [isOpen]="isDepositModalOpen" (closeModal)="closeDepositModal()"></app-deposit-modal>


<div *ngIf="isWithdrawModalOpen"
    class="withdraw-modal-backdrop fixed inset-0 z-[1200] flex items-center justify-center px-4 py-6">
    <div
        class="withdraw-modal-panel font-epilogue relative flex w-full max-w-[500px] flex-col rounded-[28px] bg-white px-6 pb-6 pt-6 shadow-[0_18px_40px_rgba(0,0,0,0.25)]">

        <button (click)="closeWithdrawModal()"
            class="absolute right-5 top-5 flex h-8 w-8 items-center justify-center rounded-full text-[#8b93a7] transition hover:bg-black/5 hover:text-[#666] cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <div class="pb-7 pt-1">
            <h2 class="text-center text-[22px] font-semibold leading-none text-black">Withdraw</h2>
        </div>
        <div class="withdraw-modal-content space-y-5">
            <div>
                <div class="mb-2 flex items-center justify-between gap-3">
                    <p class="text-base font-medium text-[#151515]">Recipient address</p>
                </div>
                <div class="flex items-start gap-3 rounded-xl border border-secondary-button-black bg-white p-3.5"
                    [class.border-red-500]="withdrawRecipient.trim() && !walletService.isValidAddress(withdrawRecipient.trim())">
                    <textarea #withdrawRecipientField [(ngModel)]="withdrawRecipient"
                        (ngModelChange)="onWithdrawRecipientChange()" placeholder="0x..." rows="1"
                        (input)="autoResizeWithdrawRecipient(withdrawRecipientField)"
                        class="min-h-[28px] min-w-0 flex-1 resize-none overflow-hidden border-0 bg-white p-0 text-[18px] font-normal leading-7 text-black outline-none transition placeholder:text-[#a5a5a5]">
                    </textarea>
                    <button type="button" (click)="useConnectedWalletAddress()"
                        class="inline-flex shrink-0 items-center gap-1.5 rounded-xl bg-[#f3f4f7] px-3 py-1.5 text-xs font-semibold text-[#171717] hover:bg-black hover:text-white duration-200 ease-in-out cursor-pointer">
                        <span>
                            <img src="assets/icons/metamask.svg" class="w-3.5 h-3.5" alt="Metamask">
                        </span>
                        Use connected
                    </button>
                </div>
                <p *ngIf="withdrawRecipient.trim() && !walletService.isValidAddress(withdrawRecipient.trim())"
                    class="mt-1.5 text-xs font-medium text-red-500">
                    Please enter a valid wallet address
                </p>
            </div>

            <div>
                <div class="mb-2 flex items-center justify-between gap-3">
                    <p class="text-base font-medium text-[#151515]">Amount</p>
                </div>
                <div class="rounded-xl border border-secondary-button-black bg-white p-3.5">
                    <div class="flex items-center gap-3">
                        <input type="text" inputmode="decimal" [(ngModel)]="withdrawAmount"
                            (ngModelChange)="onWithdrawAmountChange()" placeholder="0.00" appAmountFormat
                            [maxDecimals]="2" invalidMessage="Invalid amount format"
                            class="w-full bg-transparent text-[18px] leading-none font-normal text-black outline-none placeholder:text-[#9f9f9f]">
                        <div class="flex items-center gap-3 text-[14px] font-medium text-[#6f7483]">
                            <span>{{ withdrawToken }}</span>
                            <button type="button" (click)="setWithdrawMax()"
                                class="rounded-md bg-[#f3f4f7] px-3 py-1.5 leading-none text-[13px] font-semibold text-[#171717] hover:bg-black hover:text-white duration-200 ease-in-out cursor-pointer">
                                Max
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mt-1.5 flex items-center justify-between gap-3 text-[13px] font-normal text-[#7e7e88]">
                    <p [style.visibility]="withdrawAmountNumber > 0 ? 'visible' : 'hidden'">${{
                        withdrawAmountNumber.toFixed(2) }}</p>
                    <p>Balance: {{ availableCashBalance | number:'1.2-2' }} USDC</p>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <label class="block">
                    <span class="mb-2 block text-base font-medium text-[#151515]">Receive token</span>
                    <div class="relative current-value-dropdown withdraw-select-dropdown">
                        <button #withdrawTokenTrigger type="button" (click)="toggleWithdrawTokenDropdown($event)"
                            class="flex w-full items-center justify-between rounded-xl border border-secondary-button-black bg-white px-4 py-3.5 text-left cursor-pointer">
                            <span class="flex items-center gap-2.5">
                                <span [class]="selectedWithdrawToken.iconClass">
                                    <img src="assets/icons/usdc.svg" class="w-3.5 h-3.5" alt="usdc">
                                </span>
                                <span class="text-[15px] font-medium text-[#121212]">{{ selectedWithdrawToken.label
                                    }}</span>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none" class="transition-transform duration-200"
                                [ngClass]="{ 'rotate-x-180': isWithdrawTokenDropdownOpen }">
                                <path d="M15 8C15 8 11.6824 12 10.5 12C9.31764 12 6 8 6 8" stroke="black"
                                    stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <ul *ngIf="isWithdrawTokenDropdownOpen" [style.maxHeight.px]="withdrawTokenMenu.maxHeight"
                            [ngClass]="withdrawTokenMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                            class="absolute left-0 z-20 w-full overflow-y-auto overscroll-contain rounded-xl border border-secondary-button-black bg-white shadow-lg">
                            <li *ngFor="let token of withdrawTokenOptions" (click)="selectWithdrawToken(token)"
                                class="flex cursor-pointer items-center justify-between border-b border-secondary-button-black px-4 py-3 last:border-b-0 hover:bg-light-black-300">
                                <span class="flex items-center gap-2.5">
                                    <span [class]="token.iconClass">
                                        <img src="assets/icons/usdc.svg" class="w-3.5 h-3.5" alt="usdc">
                                    </span>
                                    <span class="text-[15px] font-medium text-[#121212]">{{ token.label }}</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </label>

                <label class="block">
                    <span class="mb-2 block text-base font-medium text-[#151515]">Receive chain</span>
                    <div class="relative current-value-dropdown withdraw-select-dropdown">
                        <button #withdrawChainTrigger type="button" (click)="toggleWithdrawChainDropdown($event)"
                            class="flex w-full items-center justify-between rounded-xl border border-secondary-button-black bg-white px-4 py-3.5 text-left cursor-pointer">
                            <span class="flex items-center gap-2.5">
                                <span [class]="selectedWithdrawChain.iconClass">
                                    <img src="assets/icons/polygon.svg" class="w-3.5 h-3.5" alt="polygon">
                                </span>
                                <span class="text-[15px] font-medium text-[#121212]">{{ selectedWithdrawChain.label
                                    }}</span>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none" class="transition-transform duration-200"
                                [ngClass]="{ 'rotate-x-180': isWithdrawChainDropdownOpen }">
                                <path d="M15 8C15 8 11.6824 12 10.5 12C9.31764 12 6 8 6 8" stroke="black"
                                    stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <ul *ngIf="isWithdrawChainDropdownOpen" [style.maxHeight.px]="withdrawChainMenu.maxHeight"
                            [ngClass]="withdrawChainMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                            class="absolute left-0 z-20 w-full overflow-y-auto overscroll-contain rounded-xl border border-secondary-button-black bg-white shadow-lg">
                            <li *ngFor="let chain of withdrawChainOptions" (click)="selectWithdrawChain(chain)"
                                class="flex cursor-pointer items-center justify-between border-b border-secondary-button-black px-4 py-3 last:border-b-0 hover:bg-light-black-300">
                                <span class="flex items-center gap-2.5">
                                    <span [class]="chain.iconClass">
                                        <img src="assets/icons/polygon.svg" class="w-3.5 h-3.5" alt="polygon">
                                    </span>
                                    <span class="text-[15px] font-medium text-[#121212]">{{ chain.label }}</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </label>
            </div>

            <div *ngIf="withdrawAmountNumber > 0" class="space-y-3 pt-1">
                <div class="flex items-end justify-between gap-3">
                    <p class="text-base font-medium text-[#151515]">You will receive</p>
                    <p class="text-base font-semibold text-[#111111] text-right">{{ estimatedReceiveAmount }} {{
                        withdrawToken }}</p>
                </div>
            </div>
        </div>

        <button type="button" (click)="handleWithdraw()" [disabled]="!isWithdrawFormValid || isProcessing"
            class="mt-5 w-full flex items-center justify-center gap-2.5 shrink-0 rounded-[14px] bg-black px-5 py-4 text-[17px] font-medium text-white transition hover:bg-secondary-button-black hover:text-black disabled:cursor-not-allowed disabled:bg-light-black-200">
            <div class="flex items-center gap-2" *ngIf="isProcessing">
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
                <span>Processing...</span>
            </div>
            <span *ngIf="!isProcessing">Withdraw</span>
        </button>
    </div>
</div>